



























import { Vue, Component, Prop } from 'vue-property-decorator'
import { date } from 'quasar'
import store from 'src/assets/store'
import icon from 'components/presenter/item/ItemIcon'
import { ItemType, Session } from 'src/graphql/types'

@Component
export default class PresenterLayoutActivityDashboardSessionItem extends Vue {
  ItemType = ItemType
  icon = icon
  formatDate = date.formatDate
  store = store

  @Prop()
  readonly session!: Session

  @Prop()
  readonly to!: string

  get isSessionStarted () {
    return this.session.startedAt ? new Date(this.session.startedAt) < store.now() : false
  }

  get at () {
    return this.isSessionStarted && this.session.stoppedAt ? this.session.stoppedAt : this.session.startedAt
  }
}
